import { render, staticRenderFns } from "./LibraryReadingLanguageEditor.vue?vue&type=template&id=4403bd9e&"
import script from "./LibraryReadingLanguageEditor.vue?vue&type=script&lang=ts&"
export * from "./LibraryReadingLanguageEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports